import { render, staticRenderFns } from "./TrainingAssessment.vue?vue&type=template&id=2cbb8180"
import script from "./TrainingAssessment.vue?vue&type=script&lang=ts"
export * from "./TrainingAssessment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports